<template>
  <div>
    <section class="todoapp">
      <Header />
      <TodoList />
      <Footer />
    </section>
    <Colophon />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import TodoList from "./components/TodoList.vue";
import Footer from "./components/Footer.vue";
import Colophon from "./components/Colophon.vue";

import store from "./store/todo-list";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    Header,
    TodoList,
    Footer,
    Colophon
  },
  methods: {
    ...mapActions("todoList", ["load", "save"])
  },
  computed: {
    ...mapGetters("todoList", ["todos"])
  },
  mounted() {
    this.load();
  },
  watch: {
    todos: {
      handler() {
        this.save();
      },
      deep: true
    }
  }
};
</script>

<style>
@import "./assets/todomvc.css";
</style>
